import { avatarIcon } from '@jg/icons';
import ImageWithFallback from '@jg/image-with-fallback';
import Svg from '@jg/svg';
import classNames from 'classnames';
import Preact from 'preact';
import urlJoin from 'url-join';
import { clientConfig } from '../../config';
import testId from '../../helpers/testId';
import { RenderButton as MenuRenderButton } from '../Menu';

/**
 * Function that returns a menu-button render function
 */
const loggedInMenuButton = ({
  avatar,
  name,
  showPip,
}: {
  avatar: string;
  name: string;
  showPip: boolean;
}): MenuRenderButton => {
  const renderMenuButton: MenuRenderButton = ({ caret }) => {
    const avatarWithFallback = (
      <ImageWithFallback
        src={
          avatar &&
          urlJoin(clientConfig.imageCDNUri, avatar, '?template=size75x75face')
        }
        alt=""
        className={classNames(
          testId('logged-in-menu-button__avatar'),
          'jg-chrome-header__user-avatar',
          'jg-br--circle',
        )}
        fallback={
          <Svg markup={avatarIcon} className="jg-chrome-header__user-avatar" />
        }
      />
    );

    return [
      <div className="jg-display-ib">
        {showPip ? (
          <div className="pip-wrapper">
            <div className="pip jg-background--sunset-red jg-position-absolute jg-color--white jg-text--center jg-br--circle">
              1<span className="jg-sr-only"> pending notification</span>
            </div>
          </div>
        ) : null}
        {avatarWithFallback}
      </div>,
      <span className="jg-display-n jg-display-ib@xl jg-align--vertical-middle">
        <span
          className={classNames(
            testId('logged-in-menu-button__name'),
            'jg-space-mlsm',
          )}
        >
          {name}
        </span>
        {caret}
      </span>,
    ];
  };

  return renderMenuButton;
};

export default loggedInMenuButton;
